/**
 * Founder Adapter
 * Authority: ADAPTER AGENT (Stability V2)
 */
import { getContractDefaults } from '../contracts/render_contracts';

export const adaptFounder = (raw) => {
    const d = getContractDefaults('Founder');
    if (!raw) return d;

    // Name Derivation Logic (Centralized)
    const fullName = raw.full_name ||
        `${raw.first_name || ''} ${raw.last_name || ''}`.trim() ||
        d.display_name;

    return {
        ...d,
        id: raw.id || raw._id || "",
        display_name: fullName,
        subtitle: raw.startup_name || d.subtitle,
        email: raw.email || d.email,
        contact_status: raw.contact_status || d.contact_status,
        email_status: raw.email_status || d.email_status,
        last_contact_label: raw.last_contact_date ? new Date(raw.last_contact_date).toLocaleDateString() : d.last_contact_label,
        avatar_initial: fullName.charAt(0).toUpperCase() || d.avatar_initial
    };
};
